import React, { useEffect } from 'react';
import ReactSlickHero from '../components/ReactSlickHero';
import Services from '../components/Services';
import Countries from '../components/Countries';
import iskurLogo from '../assets/iskur-logo.png';
import employmentOfficeLogo from '../assets/ozel-istihdam-burosu.png';
import '../styles/HomePage.css';

const HomePage = () => {
  // Component mount olduğunda sayfayı en üste kaydır
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="home-page">
      <div className="home-page-certifications">
        <img src={iskurLogo} alt="İŞKUR - Türkiye İş Kurumu" width="116" height="70" />
        <img src={employmentOfficeLogo} alt="İŞKUR Özel İstihdam Bürosu" width="64" height="64" />
      </div>
      <ReactSlickHero />
      <Services />
      <Countries isHomePage={true} />
      <section className="cta-section">
        <div className="container">
          <h2>Hayalinizdeki Kariyere Bir Adım Daha Yaklaşın</h2>
          <p>Uzman ekibimiz, Avrupa'daki yeni hayatınıza adım atmanız için yanınızda.</p>
          <a href="/iletisim" className="btn btn-primary">Hemen İletişime Geçin</a>
        </div>
      </section>
    </div>
  );
};

export default HomePage;